import { render } from "./BaseFavorite.vue?vue&type=template&id=a124c874&scoped=true"
import script from "./BaseFavorite.vue?vue&type=script&lang=js"
export * from "./BaseFavorite.vue?vue&type=script&lang=js"

import "./BaseFavorite.vue?vue&type=style&index=0&id=a124c874&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a124c874"]])

export default __exports__